import { Heading } from "components/common/Heading";
import { ReactNode } from "react";
import { Button, Col } from "reactstrap";
import { brand } from "services/envService";
import { redirectTo } from "util/redirect";
import {
  BOUNCE_BACK_LOAN_LINKS,
  EXIT_BUTTON_TEXT,
  APPLICATION_CANCELLED_TEXT,
} from "./HardStops.const";

const BRAND = brand();
const onExit = () => redirectTo(BOUNCE_BACK_LOAN_LINKS[BRAND]);

type DefaultHardStopProps = {
  header: string;
  children: ReactNode;
};

export const DefaultHardStop = ({ header, children }: DefaultHardStopProps) => {
  return (
    <Col className="content-body">
      <div className="hardStop-container">
        <div className="hardStop-content-wrapper">
          <Heading title={header}>
            <span className="hardStop-message">{children}</span>
            <br />
            <p className="hardStop-message newline">
              {APPLICATION_CANCELLED_TEXT}
            </p>
          </Heading>
          <div className="hardStop-button-container">
            <Button size="lg" color="primary" onClick={onExit}>
              {EXIT_BUTTON_TEXT}
            </Button>
          </div>
        </div>
      </div>
    </Col>
  );
};
